import React, { ChangeEventHandler, FocusEvent } from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';

/**
 * RegistrationNumberFormコンポーネント用のPropsです。
 * @interface RegistrationNumberFormProps
 */
interface RegistrationNumberFormProps {

  /**
   * 索引
   * @type {number}
   * @memberof RegistrationNumberFormProps
   */
  index: number;

  /**
   * 登録番号
   * @type {InputFieldState}
   * @memberof RegistrationNumberFormProps
   */
  registrationNumber: InputFieldState;

  /**
   * 登録番号を設定する関数
   * @memberof RegistrationNumberFormProps
   */
  onChange: (index: number, updatedValue: string) => void;
}

/**
 * 登録番号フォームのコンポーネントです。
 * @param {number} props.index - 索引
 * @param {InputFieldState} props.registrationNumber - 登録番号
 * @param {function} props.onChange - 登録番号が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 登録番号フォームのJSX要素
 */
const RegistrationNumberForm: React.FC<RegistrationNumberFormProps> = ({index, registrationNumber, onChange}) => {

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された登録番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleBlur = (event: FocusEvent<HTMLInputElement>): void => {
    const halfWidthText = event.target.value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    const deleteNonNumberInputValue = halfWidthText.replace(/[^0-9]/g, '').substring(0, 7);
    const formatRegistrationNumber: string = deleteNonNumberInputValue ? ('0000000' + deleteNonNumberInputValue).slice(-7) : deleteNonNumberInputValue;
    onChange(index, formatRegistrationNumber);
  }

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された登録番号を引数にonChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    onChange(index, event.target.value);
  };

  return (
    <Form.Group>
      <Form.Control
        type="text"
        value={registrationNumber.value}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder="特許（登録）番号を入力してください。"
        maxLength={7}
      />
      {registrationNumber.errorMessage !== '' ? <div className="text-end text-danger small">{registrationNumber.errorMessage}</div> : ''}
    </Form.Group>
  );
}

export default RegistrationNumberForm;